export default __webpack_public_path__ + "static/7-1f501614470df27d3457325d6521717e.jpg";